import createReactContext from '@ant-design/create-react-context';
export var TreeContext = createReactContext(null);


//////////////////
// WEBPACK FOOTER
// ./~/rc-tree/es/contextTypes.js
// module id = 1682
// module chunks = 6